<div *ngIf="casesList && casesList.length == 0" class="noResults">
    <mat-icon>folder_open</mat-icon>
    <strong>{{'No records found' | translate}}</strong>
</div>
<!-- <div *ngIf="metaFieldSetting && groupedData && casesList && casesList.length > 0">
    <div *ngFor="let date of objectKeys(groupedData)">
        <div class="dateTitle">{{ date }}</div>
        <div class="caseItem" [class.noBorder]="index === groupedData[date].length - 1" fxLayout="row"
            fxLayout.lt-md="column" fxFlex fxLayoutGap="20px" *ngFor="let item of groupedData[date];let index = index">
            <div fxFlex="10" class="box" fxLayout="column" fxLayoutGap="2vh" class="dateColumn">
                <div class="dateCss">{{ item.createdAt | date: 'yyyy/MM/dd'}}</div>
                <div class="timeCss">{{ item.createdAt | date: 'HH:mm' }}</div>
            </div>
            <div fxFlex="15" class="box" fxLayout="column" fxLayoutGap="2vh">
                {{item['department']}}
                <div><span>{{'Case Type' | translate}}</span>: {{item['casetype']}}
                </div>
                <div><span>{{'Case number' | translate}}</span>: {{item['case_id']}}</div>
            </div>
            <div fxFlex="35" class="box" fxLayout="column" fxLayoutGap="2vh">
                <div class="caseTitle" (click)="openCase(item._id)"><span *ngIf="item.name">{{ item.name }}</span><span
                        *ngIf="!item.name">{{ item.case_id }}</span></div>
                <div class="caseDescription">{{ item.description }}</div>
            </div>
            <div fxFlex="30" class="box" fxLayout="column" fxLayoutGap="2vh" *ngIf="locale === 'en'">
                <div class="caseAddress" (click)="openCaseMap(item._id)">
                    <span>{{ item.address }}</span>
                </div>
            </div>
            <div fxFlex="30" class="box" fxLayout="column" fxLayoutGap="2vh" *ngIf="locale === 'ja'">
                <div class="caseAddress" (click)="openCaseMap(item._id)">
                    <span>{{ item.address_jp }}</span>
                </div>
            </div>
            <div fxFlex="10" class="box" fxLayout="column" fxLayoutGap="2vh" fxLayoutAlign="center center"
                *ngIf="!isInvestigator">
                <button mat-raised-button style="width: fit-content;" 
                    (click)="edit(item, index)">{{'Edit' |
                    translate}}</button>
            </div>
        </div>
    </div>
</div> -->
<div class="cases-list" *ngIf="metaFieldSetting && casesList && casesList.length > 0">
    <div class="list-heading">
        <div class="heading-title">
            <mat-icon>list</mat-icon>
            <span>{{'Cases' | translate}}</span>
        </div>
        <span class="record-count">{{ totalCount }}</span>
    </div>

    <article class="caseItem" *ngFor="let item of casesList; let index = index" (click)="openCase(item._id)"
        tabindex="0" role="button" (keyup.enter)="openCase(item._id)">
        <div class="case-accent"></div>

        <div class="dateColumn">
            <div class="dateCss">{{ (item.time_of_occurrence || item.createdAt) | date: 'yyyy/MM/dd'}}</div>
            <div class="timeCss">{{ (item.time_of_occurrence || item.createdAt) | date: 'H:mm' }}</div>
        </div>

        <div class="case-main">
            <div class="case-title-row">
                <div class="caseTitle">
                    <span *ngIf="item.name">{{ item.name }}</span>
                    <span *ngIf="!item.name">{{ item.case_id }}</span>
                </div>
                <div class="caseType" *ngIf="item['casetype']?.name" [style.background]="item['casetype']?.color || ''"
                    [style.color]="!item.casetype?.color || item.casetype?.color == '#ffffff' || item.casetype?.color == 'white' ? 'black' : 'white'">
                    {{(item['casetype']?.name || '') | truncate: ['100','...']}}
                </div>
            </div>

            <div class="case-meta">
                <div class="meta-item case-id">
                    <mat-icon>tag</mat-icon>
                    <span>{{ item.case_id }}</span>
                </div>
                <div class="meta-item" *ngIf="item['department']">
                    <mat-icon>account_balance</mat-icon>
                    <span>{{item['department']}}</span>
                </div>
            </div>

            <div class="caseAddress">
                <mat-icon>location_on</mat-icon>
                <span *ngIf="locale === 'en'">{{ item.address || '—' }}</span>
                <span *ngIf="locale === 'ja'">{{ item.address_jp || '—' }}</span>
            </div>
        </div>

        <div class="dataContent">
            <span class="content-label">{{ 'Description' | translate }}</span>
            <div class="caseDescription">{{ item.description || '—' }}</div>
        </div>

        <div class="case-actions">
            <button mat-icon-button class="openCase" [matTooltip]="'View' | translate" tabindex="-1">
                <mat-icon>arrow_forward</mat-icon>
            </button>
            <button mat-stroked-button class="caseEdit" (click)="edit($event,item, index)"
                *ngIf="!isInvestigator && !isReadOnly">
                <mat-icon>edit</mat-icon>
                <span>{{'Edit' | translate}}</span>
            </button>
        </div>
    </article>
</div>
